import { useApi } from "hooks/api";
import { useQuery } from "react-query";
import Loader from "components/ui/elements/loader/Loader";
import { MoodBoard } from "types/qbank/moodboard";
import { useCallback, useState } from "react";
import SearchBar from "./SearchBar";
import MoodBoardItem from "./MoodBoardItem";

const filterItems = (items: MoodBoard[], keyword: string): MoodBoard[] => {
    return items.filter((item) => item.name.toLowerCase().includes(keyword.toLowerCase()));
};

export default function MoodBoardList(props: {
    close: () => void;
}) {
    const { getmoodboards } = useApi();
    const [filteredMoodboardList, setfilteredMoodboardList] = useState<MoodBoard[]>();
    const [keywordList, setKeywordList] = useState<string>("");

    const {
        isLoading: moodBoardLoading,
        isError: moodBoardHasError,
        error: moodBoardError,
        data: moodBoards,
    } = useQuery(
        "getmoodboards",
        () => getmoodboards(),
        {
            retry: 0,
            staleTime: Infinity,
        }
    );

    const filter = useCallback((keyword: string) => {
        const filteredList = filterItems(moodBoards || [], keyword);
        setfilteredMoodboardList(filteredList);
        setKeywordList(keyword);
    }, [moodBoards]);

    const removeSearchItem = useCallback(() => {
        setfilteredMoodboardList(moodBoards);
        setKeywordList("");
    }, [moodBoards]);

    if (moodBoardLoading) {
        return <Loader />;
    }
    if (moodBoardHasError)
        console.error("Error fetching mood boards:", moodBoardError);



    return (
        <>
            {moodBoards !== undefined && moodBoards.length >= 20 && (
                <div className="search-bar-container">
                    <SearchBar
                        filter={filter}
                        removeSearchItem={removeSearchItem}
                        type="Moodboard"
                        keywordList={keywordList}
                    ></SearchBar>
                </div>
            )}

            {!filteredMoodboardList
                ? moodBoards?.map((moodboard) => (
                    <MoodBoardItem
                        key={moodboard.id}
                        moodboard={moodboard} close={props.close} />
                ))
                : filteredMoodboardList.map((moodboard) => (
                    <MoodBoardItem
                        key={moodboard.id}
                        moodboard={moodboard} close={props.close} />
                ))}
        </>
    );
}